"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("lazysizes");
var body = document.querySelector('body');
var menuToggle = document.querySelector('#menutoggle');
menuToggle.addEventListener('click', function (event) {
    if (body.classList.contains('menu-open')) {
        body.classList.remove('menu-open');
        menuToggle.setAttribute('aria-expanded', 'false');
    }
    else {
        body.classList.add('menu-open');
        menuToggle.setAttribute('aria-expanded', 'true');
    }
}, false);
var Tab = /** @class */ (function () {
    function Tab(button, content) {
        this.button = button;
        this.content = content;
        this.button = button;
        this.content = content;
    }
    Tab.prototype.isOpen = function () {
        return this.button.getAttribute('aria-expanded');
    };
    Tab.prototype.setHeight = function () {
        this.content.style.setProperty('--height', this.content.scrollHeight + 'px');
    };
    Tab.prototype.open = function () {
        this.content.classList.add('is-open');
        this.content.setAttribute('aria-hidden', 'false');
        this.button.setAttribute('aria-expanded', 'true');
        this.button.setAttribute('aria-selected', 'true');
    };
    Tab.prototype.close = function () {
        this.content.classList.remove('is-open');
        this.content.setAttribute('aria-hidden', 'true');
        this.button.setAttribute('aria-expanded', 'false');
        this.button.setAttribute('aria-selected', 'false');
    };
    return Tab;
}());
var Tabs = /** @class */ (function () {
    function Tabs(tabList) {
        this.tabList = tabList;
        this.tabList = tabList;
    }
    Tabs.prototype.getOpenTab = function () {
        return this.tabList.find(function (tab) { return tab.isOpen() == 'true'; });
    };
    Tabs.prototype.hasOpenTab = function () {
        if (this.getOpenTab() != undefined) {
            return true;
        }
        return false;
    };
    Tabs.prototype.toggleTab = function (tab) {
        if (tab === this.getOpenTab()) {
            tab.close();
        }
        else {
            tab.open();
            this.tabList.forEach(function (otherTab) {
                if (otherTab != tab) {
                    otherTab.close();
                }
            });
        }
    };
    Tabs.prototype.openTab = function (tab) {
        if (!this.hasOpenTab()) {
            tab.open();
        }
        else {
            this.toggleTab(tab);
        }
    };
    Tabs.prototype.init = function () {
        var _this = this;
        this.tabList.forEach(function (tab) {
            // tab.setHeight();
            tab.button.addEventListener('click', function () { return _this.toggleTab(tab); }, false);
        });
    };
    return Tabs;
}());
var sectionTabs = new Tabs(Array.from(document.querySelectorAll('.section-tab__header')).map(function (tabHeader) {
    var tabContent = document.querySelector('#' + tabHeader.getAttribute('aria-controls'));
    return new Tab(tabHeader, tabContent);
}));
sectionTabs.init();
var gdprPopup = document.querySelector('#gdprpopup');
var gdprButton = gdprPopup.querySelector('#gdprclose');
gdprButton.addEventListener('click', function (e) {
    e.preventDefault();
    gdprPopup.remove();
});
